import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { Ruolo } from '@ideapa/app-shared-ruolo';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'utente';
export const ENTITY_PLURAL = 'utenti';

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;
export const getGridColumn = (roles: Ruolo[]) => {
  const gridColumns: EntityListField[] = [
    // {
    //   elementLabel: 'Id',
    //   filterType: FilterType.number,
    //   fieldType: FieldType.integer,
    //   field: 'id',
    // },
    {
      elementLabel: 'Cognome',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'cognome',
      sortable: true,
      sort: 'asc',
    },
    {
      elementLabel: 'Nome',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'nome',
    },
    {
      elementLabel: 'Email',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'email',
    },
    {
      elementLabel: 'Ruolo',
      filterType: FilterType.enum,
      fieldType: FieldType.enum,
      field: 'role.name',
      elementValues: roles.map((r) => ({
        value: r.name,
        description: r.name,
      })),
    },
    {
      elementLabel: 'Valido dal',
      filterType: FilterType.date,
      fieldType: FieldType.date,
      field: 'validoDal',
      initialHideColumn: true,
    },
    {
      elementLabel: 'Valido al',
      filterType: FilterType.date,
      fieldType: FieldType.date,
      field: 'validoAl',
      initialHideColumn: true,
    },
    {
      elementLabel: 'Codice Fiscale',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'codiceFiscale',
      initialHideColumn: true,
    },
    {
      elementLabel: 'Note',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'note',
      initialHideColumn: true,
      hideFilter: true,
    },
  ];
  return gridColumns;
};
export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
